//define root getters
export const hypoInput = (state, rootState, getters, rootGetters) => {
    const { hypo, investments, config } = state;
    const reportDetailsConfig = config.reportDetailsConfig ? config.reportDetailsConfig : undefined;
    const assetGroups = hypo.assetAllocation && hypo.assetAllocation.length > 0 ? hypo.assetAllocation : undefined;
    let { portfolioList } = investments;
    portfolioList = portfolioList.map(portfolio => {
        /* eslint-disable no-unused-vars */
        const { pctAllocateBy, priceType, ...portfolioData } = portfolio;
        return processSubSequents(portfolioData);
    });
    return {
        hypoId: hypo.hypoId,
        hypoName: hypo.hypoName,
        hypoType: hypo.hypoType,
        lastCompletedStep: hypo.lastCompletedStep,
        globalSetting: {
            assetGroups: assetGroups
        },
        portfolioList: portfolioList,
        reportSetting: rootGetters["reportSetting/reportSetting"],
        gcfc: reportDetailsConfig
    };
};

const processSubSequents = portfolio => {
    const { subSequentSetting, ...portfolioData } = portfolio;
    if (subSequentSetting) {
        let { subSequents = [], ...oSubSequentSetting } = subSequentSetting;
        subSequents = subSequents
            .filter(item => typeof item.visible === "undefined" || item.visible)
            .map(item => {
                /* eslint-disable no-unused-vars */
                const { visible, ...newItem } = item;
                return newItem;
            });
        if (subSequents.length > 0) {
            return {
                ...portfolioData,
                subSequentSetting: {
                    ...subSequentSetting,
                    subSequents
                }
            };
        }
        return {
            ...portfolioData,
            subSequentSetting: oSubSequentSetting
        };
    }
    return portfolioData;
};
